export { default } from './ContentSection';



// WEBPACK FOOTER //
// ./src/components/ContentSection/index.js